import React, { useState, useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import styles from './success.module.scss'
import { Swiper, InfiniteScroll } from 'antd-mobile'
import indexApi from '@/apis'
import { parseNum } from '@bihu/common-js'
import JointLoginPopup from '@/components/joint-login-popup/joint-login-popup'
import IosSkin from './components/ios-skin/ios-skin'

interface Props{}

const Success:React.FC<Props> = () => {
  const [search] = useSearchParams()
  const options: any = search.get('options')
  let resData: any = {}
  if (options) {
    try {
      resData = JSON.parse(decodeURIComponent(options))
    } catch {
      resData = JSON.parse(options)
    }
  }

  const { productName, applyStatus } = resData

  const [swiperList, setSwiperList] = useState<(any[])>([])
  const [currentSwiperIndex, setCurrentSwiperIndex] = useState(0)
  const [exposureProductIds, setExposureProductIds] = useState<any>([])
  const [productList, setProductList] = useState<(any[])>([])
  const [pageNum, setPageNum] = useState<number>(1)
  const [loadMoreShow, setLoadMoreShow] = useState<boolean>(false) // 是否执行加载更多
  const [hasMore, setHasMore] = useState<boolean>(false)
  const JointLoginModalRef: any = useRef()
  const [isRequest, setIsRequest] = useState<boolean>(false)

  // 获取产品列表（pageNum 变化时拉取，含首次加载）
  useEffect(() => {
    fetchProductList()
  }, [pageNum])

  const fetchProductList = () => {
    if (applyStatus === 1) {
      return
    }
    setLoadMoreShow(false)
    indexApi.getProductList({
      pageNum
    }).then(res => {
      // 多重判断是否还有更多数据
      const pageSize = res.pageSize || 15 // 默认每页15条
      const hasMoreData = res.rowList.length > 0
        && (res.totalPage ? pageNum < res.totalPage : true)
        && (res.totalRecord ? productList.length + res.rowList.length < res.totalRecord : true)
        && res.rowList.length >= pageSize

      if (res.rowList.length === 0) {
        setHasMore(false)
        return
      }

      if (pageNum === 1) {
        setSwiperList(res.rowList.slice(0, 3))
      }

      // 使用函数式更新避免状态竞争
      setProductList(prev => {
        if (pageNum === 1) {
          return res.rowList
        }
        return [...prev, ...res.rowList]
      })

      setHasMore(hasMoreData)
    })
      .finally(() => {
        setLoadMoreShow(true)
        setIsRequest(true)
      })
  }

  useEffect(() => {
    if (swiperList.length > 0) {
      onChangeSwiper(0)
    }
  }, [swiperList])

  const loadMore = async(isRetry = false) => {
    if (loadMoreShow && hasMore) {
      await new Promise(resolve => {
        setPageNum(prev => prev + 1)
        resolve(undefined)
      })
    }
  }

  // 点击产品
  const applyProduct = async(item:any, entranceType:number) => {
    let res:any = await indexApi.applyFor({
      productId: item.id,
      entranceType,
      appH5: 2
    })
    // if (res.unionLoginFlag === 1) {
    //   const params = {
    //     productId: item.id,
    //     productName: item.productName,
    //     productLogo: item.productLogo,
    //     h5Protocols: res.h5Protocols,
    //     loansLimitMax: item.loansLimitMax,
    //     entranceType,
    //     appH5: 2
    //   }
    //   // 打开产品联登授权弹窗
    //   JointLoginModalRef.current?.init(params)
    //   return
    // }
    window.location.href = res.thirdpartyTargetUrl
  }

  // 曝光
  const onChangeSwiper = (index:number) => {
    setCurrentSwiperIndex(index)
    // 判断是否已经曝光过
    const isExposure = exposureProductIds.find((item:any) => item === swiperList[index].id)
    if (isExposure) {
      return
    }
    exposureProductIds.push(swiperList[index].id)
    setExposureProductIds([...exposureProductIds])
    // 上报产品曝光
    indexApi.reportProductExposure({
      productId: swiperList[index].id,
      entranceType: 4,
      appH5: 2
    })
  }

  // 当 applyStatus === 1 时显示 IosSkin 组件
  if (applyStatus === 1) {
    return (
      <IosSkin
        productName={productName}
        applyStatus={applyStatus}
        revisit={true}
        onChange={() => undefined}
      />
    )
  }

  return (
    <div>
      {
        isRequest && <div className={styles.successWrap}>
          {
            productList.length > 0 ? <>
              <div className={styles.header}>
                <img className={styles.logoImg} src={require('@imgs/information/wft/logoIcon.png')} />
                {/* swiper start */}
                <Swiper slideSize={90} trackOffset={6} loop autoplay autoplayInterval={4000} stuckAtBoundary={false} onIndexChange={onChangeSwiper} defaultIndex={currentSwiperIndex}>
                  {
                    swiperList.map((item, index) => (
                      <Swiper.Item key={index}>
                        <div className={styles.swiperItem}>
                          <div className={`${styles.swiperItemBox} ${index === 1 ? styles.swiperItemBox2 : ''}`}>
                            <div className={styles.title}>因您资质良好, 为您推荐</div>
                            <div className={styles.product}>
                              <img className={styles.productImg} src={item.productLogo} />
                              <div className={styles.productName}>{item.externalName} · 最高可借额度(元)</div>
                            </div>
                            <div className={styles.swiperItemFooter}>
                              <div className={styles.swiperItemFooterL}>
                                <div className={styles.price}>{parseNum(item.loansLimitMax)}</div>
                                <div className={styles.productDesc}>综合年化率(单利) {item.annualInterestRate ? `${item.annualInterestRate}%` : `${parseFloat((item.monthlyInterestRate * 12).toFixed(2))}%`}起</div>
                              </div>
                              <div className={styles.swiperItemFooterR} onClick={() => applyProduct(item, 4)}>
                                <div className={styles.loan}>今日放款率92%</div>
                                <div className={styles.chooseBtn}>立即申请</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Swiper.Item>
                    ))
                  }
                </Swiper>
                {/* swiper end */}
              </div>
              {/* 更多产品列表 */}
              <div className={styles.productList}>
                <div className={styles.title}>更多精选贷款</div>
                <div className={styles.productListBox}>
                  {
                    productList.map((item, index) => (
                      <div className={styles.productListBoxItem} key={index}>
                        <div className={styles.top}>
                          <div className={`${styles.productImg} ${styles[`ranking${index + 1}`]}`}>
                            <img className={`${styles.logoImg} ${styles[`logoImgRank${index + 1}`]}`} src={item.productLogo} />
                          </div>
                          <div className={styles.productName}>{item.externalName}</div>
                          <div className={styles.labelBox}>
                            {item.labels && item.labels.length > 0
                    && item.labels.map((label: string, labelIndex: number) => (
                      <div key={labelIndex} className={`${styles.productDescTag} ${labelIndex == 0 ? '' : styles.productDescTagTwo}`}>{label}</div>
                    ))
                            }
                          </div>
                        </div>
                        <div className={styles.main}>
                          <div>
                            <div className={styles.price}>{parseNum(item.loansLimitMax)}</div>
                            <div className={styles.mainText}>额度高达(元)</div>
                          </div>
                          <div>
                            <div className={styles.interest}>{item.annualInterestRate ? `${item.annualInterestRate}%` : `${parseFloat((item.monthlyInterestRate * 12).toFixed(2))}%`}</div>
                            <div className={styles.mainText}>年利率(单利)低至</div>
                          </div>
                          <div className={styles.btnBox} onClick={() => applyProduct(item, 6)}>立即申请</div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
              {/* 更多产品列表 */}
              {/* 借款步骤 */}
              <div className={styles.borrowSteps}>
                <div className={styles.title}>快速借款 仅需3步</div>
                <div className={styles.borrowStepsBox}>
                  <div className={styles.borrowStepsItem}>
                    <img className={styles.borrowStepsItemImg} src={require('@imgs/success/product.png')} />
                    <div className={styles.borrowStepsItemTitle}>1.选择产品</div>
                  </div>
                  <img className={styles.triangleImg} src={require('@imgs/success/triangle.png')} />
                  <div className={styles.borrowStepsItem}>
                    <img className={styles.borrowStepsItemImg} src={require('@imgs/success/institution.png')} />
                    <div className={styles.borrowStepsItemTitle}>2.匹配机构</div>
                  </div>
                  <img className={styles.triangleImg} src={require('@imgs/success/triangle.png')} />
                  <div className={styles.borrowStepsItem}>
                    <img className={styles.borrowStepsItemImg} src={require('@imgs/success/embody.png')} />
                    <div className={styles.borrowStepsItemTitle}>3.提现放款</div>
                  </div>
                </div>
              </div>
            </> : <>
              <div className={styles.not}>
                <img className={styles.notImg} src={require('@imgs/success/noList.png')} />
                <div className={styles.notTitle}>抱歉，暂未匹配到合适的产品</div>
                <div className={styles.notDesc}>请稍后再来试试</div>
              </div>
            </>
          }

          {/* 借款步骤 */}
          <InfiniteScroll
            loadMore={loadMore}
            hasMore={hasMore}
            threshold={250}
            style={!hasMore ? { display: 'none' } : {}}
          >
          </InfiniteScroll>
          <JointLoginPopup ref={JointLoginModalRef}></JointLoginPopup>
        </div>
      }
    </div>

  )
}
export default Success